var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 6.847c1.557 0 2.819-1.533 2.819-3.424C9.819 1.533 9.404 0 7 0S4.182 1.533 4.182 3.423 5.444 6.847 7 6.847M12.324 12.164c.002-.031 0-.219 0 0M12.317 11.936c-.052-3.294-.482-4.232-3.774-4.826 0 0-.464.59-1.544.59s-1.543-.59-1.543-.59c-3.256.587-3.712 1.512-3.772 4.719-.005.262-.007.275-.008.245v.346S2.46 14 7 14s5.324-1.58 5.324-1.58v-.256a2 2 0 0 1-.006-.228"
})));
export { SvgPerson as ReactComponent };
export default __webpack_public_path__ + "static/media/person.a21ee8d7.svg";